import {
	Badge,
	Button,
	Divider,
	Flex,
	UsersIcon,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Stack,
	Text,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import EmptyState from "./empty-state";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../hooks/use-app-context";
import { isMobile } from "react-device-detect";

type props = {
	isOpen: boolean;
	onClose: () => void;
	onboadingSystems: OnboadingSystem[];
	firstTime: boolean;
};

export type OnboadingSystem = {
	system: string;
	name: string;
	isOnboarded: boolean;
};

const sortSystems = (os1: OnboadingSystem, os2: OnboadingSystem) => {
	if (os1.isOnboarded && !os2.isOnboarded) {
		return 1;
	} else if (!os1.isOnboarded && os2.isOnboarded) {
		return -1;
	} else {
		if (os1.name.toLowerCase() > os2.name.toLowerCase()) {
			return 1;
		} else {
			return -1;
		}
	}
};

export const SystemOnboadringModal = ({ isOpen, onClose, onboadingSystems, firstTime }: props) => {
	const { t } = useTranslation();
	const { safeArea } = useAppContext();

	return (
		<Modal onClose={() => {}} isOpen={isOpen} size={isMobile ? "full" : undefined}>
			<ModalHeader
				p={ThemeSpaceVariable.Large}
				mt={isMobile ? ThemeSpaceVariable.X2Large : ThemeSpaceVariable.None}
				minH={"unset"}
			>
				<EmptyState
					icon={UsersIcon}
					title={t("post_login_onboarding_system_title")}
					text={t("post_login_onboarding_system_text")}
				/>
			</ModalHeader>
			<ModalBody px={ThemeSpaceVariable.Large}>
				<Stack justifyContent={"space-between"} divider={<Divider />} gap={ThemeSpaceVariable.Small}>
					{onboadingSystems.sort(sortSystems).map((s) => (
						<Flex key={s.name} justifyContent={"space-between"} gap={ThemeSpaceVariable.Medium}>
							<Text fontWeight={"bold"}>{s.name}</Text>
							{!firstTime && !s.isOnboarded && (
								<Badge.Info>{t("post_login_onboarding_system_newley_added")}</Badge.Info>
							)}
						</Flex>
					))}
				</Stack>
				<Divider mt={ThemeSpaceVariable.Small} />
			</ModalBody>
			<ModalFooter pb={safeArea.bottomAsPx()}>
				<Stack
					w={"100%"}
					gap={ThemeSpaceVariable.Medium}
					p={ThemeSpaceVariable.Medium}
					pb={ThemeSpaceVariable.Large}
				>
					{/* SM-6368: Add this text when doing ticket. */}
					{/* <Text
						mx={ThemeSpaceVariable.Small}
						fontSize={ThemeFontSizeVariable.Small}
						color={ThemeColorVariable.OnSurfaceSubdued}
					>
						Vill du begränsa hur du delar dina personliga uppgifter med din arbetsgivare? Gör dina val under
						Integritet & säkerhet i menyn
					</Text> */}
					<Button variant={"primary"} size={"lg"} onClick={onClose}>
						{t("choice_next")}
					</Button>
				</Stack>
			</ModalFooter>
		</Modal>
	);
};
